module.exports = __webpack_public_path__ + "static/media/(V)_MG_5794_-_Cia_Termal_Beachewear_-_Moda_Feminina.55a556d5.jpg";